import React, { useState, useEffect } from 'react';

const ImageWithFallback = ({ 
    src, 
    alt, 
    fallbackSrc = '/placeholder-image.png', 
    ...props 
}) => {
    const [imgSrc, setImgSrc] = useState(src);
    const [hasError, setHasError] = useState(false);

    const handleError = () => {
        if (!hasError) {
             setImgSrc(fallbackSrc);
             setHasError(true);
        }
    };
    useEffect(() => {
        setImgSrc(src);
        setHasError(false);
    }, [src]);


    return (
        <img 
            src={imgSrc} 
            alt={alt}
            onError={handleError}
            {...props} 
        />
    );
};

export default ImageWithFallback; 